export default "__VITE_ASSET__CqCS$5SZ__"